<template lang="pug">
  .ymk-wrap
    .a-box-xs-1x1(v-if="color")
      .a-box-content(ref="box")
        .spinner
          i.icon-revive.color-purple.animate-spin-clockwise
        #YMK-module
</template>

<script>
  export default {
    name: "ymkWrap",

    props: {
      code: {
        type: String
      }
    },

    data() {
      return {
        YMKInterval: null,
        initialized: false,
        loaded: false,
        YMKShadeMap: {
          "2.5NNN": "BCC-17143_20180622_DYE_01_20",
          "2NAA": "BCC-17143_20180622_DYE_01_21",
          "3.5NNN": "BCC-17143_20180622_DYE_01_22",
          "2NNA": "BCC-17143_20180622_DYE_01_01",
          "3NVV": "BCC-17143_20180622_DYE_01_23",
          "3NNA": "BCC-17143_20180622_DYE_01_02",
          "4.5NNN": "BCC-17143_20180622_DYE_01_03",
          "4VR": "BCC-17143_20180622_DYE_01_118",
          "4NA": "BCC-17143_20180622_DYE_01_24",
          "4NGV": "BCC-17143_20180622_DYE_01_04",
          "4NMG": "BCC-17143_20180622_DYE_01_11",
          "5.5NNN": "BCC-17143_20180622_DYE_01_12",
          "5.5NNA": "BCC-17143_20180622_DYE_01_163",
          "5RV": "BCC-17143_20180622_DYE_01_154",
          "5NRM": "BCC-17143_20180622_DYE_01_25",
          "5NA": "BCC-17143_20180622_DYE_01_13",
          "5NAC": "BCC-17143_20180622_DYE_01_14",
          "5NGM": "BCC-17143_20180622_DYE_01_15",
          "5NGV": "BCC-17143_20180622_DYE_01_16",
          "6.5NNN": "BCC-17143_20180622_DYE_01_26",
          "6.5NNA": "BCC-17143_20180622_DYE_01_159",
          "6N": "BCC-17143_20180622_DYE_01_173",
          "6RR": "BCC-17143_20180622_DYE_01_155",
          "6NAV": "BCC-17143_20180622_DYE_01_27",
          "6NMG": "BCC-17143_20180622_DYE_01_28",
          "6NRR": "BCC-17143_20180622_DYE_01_29",
          "6NAC": "BCC-17143_20180622_DYE_01_17",
          "6NCG": "BCC-17143_20180622_DYE_01_18",
          "6NGV": "BCC-17143_20180622_DYE_01_19",
          "7.5NNA": "BCC-17143_20180622_DYE_01_172",
          "7N": "BCC-17143_20180622_DYE_01_158",
          "7RC": "BCC-17143_20180622_DYE_01_156",
          "7NCG": "BCC-17143_20180622_DYE_01_30",
          "7NCR": "BCC-17143_20180622_DYE_01_31",
          "7NGM": "BCC-17143_20180622_DYE_01_87",
          "7NGV": "BCC-17143_20180622_DYE_01_88",
          "7NVA": "BCC-17143_20180622_DYE_01_89",
          "8CC": "BCC-17143_20180622_DYE_01_157",
          "8AV": "BCC-17143_20180622_DYE_01_90",
          "8NGC": "BCC-17143_20180622_DYE_01_91",
          "8NGV": "BCC-17143_20180622_DYE_01_92",
          "8NVA": "BCC-17143_20180622_DYE_01_93",
          "9AV": "BCC-17143_20180622_DYE_01_94",
          "9NA": "BCC-17143_20180622_DYE_01_95",
          "9NG": "BCC-17143_20180622_DYE_01_96",
          "9NGV": "BCC-17143_20180622_DYE_01_107",
          "9NV": "BCC-17143_20180622_DYE_01_108",
          "10NA": "BCC-17143_20180622_DYE_01_109",
          "10NGV": "BCC-17143_20180622_DYE_01_110",
          "10NVA": "BCC-17143_20180622_DYE_01_111",
          "11AA": "BCC-17143_20180622_DYE_01_115",
          "11GV": "BCC-17143_20180622_DYE_01_116",
          "11VA": "BCC-17143_20180622_DYE_01_117"
        },
        YMKLoadedEventListener: null,
        YMKClosedEventListener: null,
        YMKVideoLoadedEventListener: null,
        YMKPhotoLoadedEventListener: null,
        YMKPhotoSavedEventListener: null,
        YMKFBShareEventListener: null,
        YMKEmailShareEventListener: null
      }
    },

    computed: {
      color() {
        if (this.initialized && this.loaded && this.code && YMK) {
          YMK.applyMakeupBySku(this.YMKShadeMap[this.code]);
        }
        return this.code;
      }
    },

    methods: {
      addEventListeners() {
        this.YMKLoadedEventListener = YMK.addEventListener('loaded', () => {
          this.$emit('loaded');
          this.loaded = true;
        });

        this.YMKClosedEventListener = YMK.addEventListener('closed', () => {
          this.$emit('closed');
          this.loaded = false;
        });

        this.YMKVideoLoadedEventListener = YMK.addEventListener('videoLoaded', () => {
          this.trackEvent('AR Try it On Live', { product_code: this.code });
        });

        this.YMKPhotoLoadedEventListener = YMK.addEventListener('photoLoaded', () => {
          this.trackEvent('AR Try it On Upload Photo', { product_code: this.code });
        });

        this.YMKPhotoSavedEventListener = YMK.addEventListener('photoSaved', () => {
          this.trackEvent('AR Photo Saved', { product_code: this.code });
        });

        this.YMKFBShareEventListener = YMK.addEventListener('shareToFBSuccess', () => {
          this.trackEvent('AR FB Share', { product_code: this.code });
        });

        this.YMKEmailShareEventListener = YMK.addEventListener('shareToEmailSuccess', () => {
          this.trackEvent('AR Email Share', { product_code: this.code });
        });
      },

      clearEventListeners() {
        YMK.removeEventListener(this.YMKLoadedEventListener);
        YMK.removeEventListener(this.YMKClosedEventListener);
        YMK.removeEventListener(this.YMKVideoLoadedEventListener);
        YMK.removeEventListener(this.YMKPhotoLoadedEventListener);
        YMK.removeEventListener(this.YMKPhotoSavedEventListener);
        YMK.removeEventListener(this.YMKFBShareEventListener);
        YMK.removeEventListener(this.YMKEmailShareEventListener);
      }
    },

    mounted() {
      var pScript = document.getElementById('perfectcorp-ymk-script');
      if (!pScript) {
        (function(d,k){
          var s = d.createElement('script');
          s.id = 'perfectcorp-ymk-script';
          s.type = 'text/javascript';
          s.async = true;
          s.src = 'https://plugins-media.perfectcorp.com/c7065/sdk.js?apiKey=' + k;
          var x = d.getElementsByTagName('script')[0];
          x.parentNode.insertBefore(s, x);
        })(document, 'uXysj3wfFLDE3KatGPcWNw==');
      }

      this.YMKInterval = setInterval(() => {
        try {
          if (YMK && this.$refs.box) {
            YMK.init({
              width: this.$refs.box.clientWidth,
              height: this.$refs.box.clientHeight,
              disable2ColorComparison: true,
              enableFBSharing: true,
              enableEmailSharing: true,
              skinSmoothStrength: 0
            });
            this.initialized = true;
            this.addEventListeners();
            YMK.open();

            clearInterval(this.YMKInterval);
          }
        } catch(err) {
          if (err.message != 'YMK is not defined') {
            throw err;
          }
        }
      }, 200);
    },

    destroyed() {
      try {
        clearInterval(this.YMKInterval);
        if (YMK) {
          this.clearEventListeners();
          YMK.close();
        }
      } catch(err) {
        if (err.message != 'YMK is not defined' && !err.message.includes('Minified React error #40')) {
          throw err;
        }
      }
    }
  }
</script>

<style lang="stylus">
  .ymk-wrap
    min-width 300px
    max-width 600px
    
    .spinner
      position absolute
      top 50%
      left 50%
      width 3em
      font-size 3em
      margin-left -1.5em
      margin-top -1.5em
      padding 0.5em
      
      .icon-revive
        display inline-block
        transform-origin 48.5% 55.5%
        font-size 2em
        
        &:before
          margin 0
</style>
